import React from 'react';
import ThisProject from '../ThisProject';
import { Gallery } from '../../components/imports';

const Content = () => {

  // const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          {/* <MotionContent imgRef={heroRef} height={"110vh"} className="overflow-visible">
            <ImageMedia
              key={"hero"+thisProject.client}
              src={require('./_cover.jpg')}
              className="relative md:landscape:scale-[120%]= full object-cover object-top"
            />
          </MotionContent> */}
          <Gallery resp title="desqGallery" content={[
            { type: "image", src: require('./_cover.jpg') },
            { type: "image", src: require('./_cover.jpg') },
          ]} />
        </div>
      )}
    </ThisProject>
  )
}

export default Content